import React, { Component } from "react";
import { Container, Title } from "./individual_user/style";
import PopularGraph from "./PopularGraph";
import EmptyModal from "../modal/EmptyModal";

class PopularTopic extends Component {
    state = {}

    render() {
    	const { id, data } = this.props;
    	const newData = makeData(data);
    	return (
    		<Container style={{ height: 335, maxHeight: 335, marginTop: 0 }}>
    			<Title>Popular Topics</Title>
    			{
    				newData.length > 0 ?
    					<div>
    						<PopularGraph
    							visualColorKey={id}
    							data={newData.sort((a, b) => (a.value - b.value)).reverse().slice(0, 3)}
    							id={`bar_graph_${id}`} />
    						{
    							newData.length > 4 &&
                                <div style={{ margin: "0 0 0 16px" }}>
                                	<a style={{ color: "#00c4b3" }} onClick={() => this.refs.modal.showModal()}>
                                        Load more
                                	</a>
                                </div>
    						}
    						<EmptyModal title="Popular Topics" ref='modal'>
    							<PopularGraph
    								visualColorKey={id}
    								max data={newData} id={`modal_graph_${id}`} />
    						</EmptyModal>
    					</div>
    					: <div style={{ textAlign: "center" }}>No data</div>
    			}
    		</Container>
    	);
    }
}

const makeData = (data) => {
	if (data && Object.keys(data).length > 0) {
		return Object.keys(data).map((key, index) => {
			return { topic: key, value: data[key] };
		});
	} else {
		return [];
	}
};
/*
"topic": {
        "work": 10,
        "money": 20,
        "love": 30
    }
}
*/

// const data = [
//     { topic: 'Work', value: 70 },
//     { topic: 'Money', value: 30 },
//     { topic: 'Love', value: 20 },
//     { topic: 'Sex', value: 10 },
// ];

export default PopularTopic;


// WEBPACK FOOTER //
// ./src/components/report/PopularTopic.js